import React, { useState } from "react";
import Main from "../Stays/Main";

const Landing = () => {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [ok, setOk] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || submitting) return;
        setSubmitting(true);
        // Avoid CORS preflight: use form data and no custom headers
        const form = new FormData();
        form.append("email", email);
        form.append("ts", new Date().toISOString());
        const endpoint =
            process.env.REACT_APP_WEBHOOK_URL ||
            process.env.REACT_APP_SHEET_WEB_APP_URL ||
            "https://hook.us1.make.com/ns2d85zytcx752xl6xpr2ks4ezq6nqsw";
        fetch(endpoint, {
            method: "POST",
            mode: "no-cors",
            body: form,
        })
            .then(() => setOk(true))
            .catch(() => setOk(false))
            .finally(() => setSubmitting(false));
    };

    return (
        <Main homeLayout email={email} setEmail={setEmail} onSubmit={handleSubmit} submitting={submitting} ok={ok} />
    );
};

export default Landing;


